module.exports = __webpack_public_path__ + "img/round.be388481.png";